import { eLynxObjectTypeEnum } from "../../common/enums/eLynxObjectType";
import restService from "../rest-service/RestService";
import { AvailableSetpointModel, IEditDTO, IEditTagSearchCriteriaDTO, IEditTagSearchResultDeviceDTO, IReferenceDTO, ISummaryDTO, ISummaryGroupedObjectsDTO, ISummaryObjectsDTO, ISummarySearchDTO, ISummaryUsageDTO, defaultEditSetpoint } from "./Models";

type SetpointAdminQueryParams = {
    page?: number;
    pageSize?: number;
    organizationID?: number;
    groupingObjectType?: eLynxObjectTypeEnum
}
const SetpointAdministrationDataService = {

    getSetpoints: async function (
        groupID: number,
        //page: number, 
        //pageSize: number, 
        searchCriteria: ISummarySearchDTO,
        signal?: AbortSignal
    ): Promise<ISummaryDTO> {

        const path = `/groups/${groupID}/setpoints/admin`;

        // const queryParams: SetpointAdminQueryParams = {
        //     page,
        //     pageSize
        // };

        const response = await restService.post<ISummarySearchDTO, ISummaryDTO>(path, searchCriteria, signal);
        return response.data;
    },

    getAvailableSetpoints: async function (
        groupID: number,
        signal?: AbortSignal
    ): Promise<Array<AvailableSetpointModel>> {
        const path = `/groups/${groupID}/availablesetpoints`;

        const response = await restService.get<Array<AvailableSetpointModel>>(path, signal);
        return response.data;
    },

    getGroupedSetpoints: async function (
        groupID: number,
        objectType: eLynxObjectTypeEnum,
        searchCriteria: ISummarySearchDTO,
        signal?: AbortSignal
    ): Promise<ISummaryGroupedObjectsDTO> {
        const path = `/groups/${groupID}/setpoints/admin/grouped`;

        const queryParams: SetpointAdminQueryParams = {
            groupingObjectType: objectType
        };

        const response = await restService.post<ISummarySearchDTO, ISummaryGroupedObjectsDTO, SetpointAdminQueryParams>(path, searchCriteria, signal, undefined, queryParams);
        return response.data;
    },

    getSetpointUsage: async function(groupID: number, 
        setpointID: number,
        signal?: AbortSignal
    ): Promise<ISummaryUsageDTO[]> {

        const path = `/groups/${groupID}/setpoints/${setpointID}/usage/admin`;
        const response = await restService.get<ISummaryUsageDTO[]>(path, signal);
        return response.data;
    },

    getObjectsWithoutSetpoints: async function(groupID: number,
        searchCriteria: ISummarySearchDTO,
        signal?: AbortSignal
    ) : Promise<ISummaryObjectsDTO> {

        const path = `/groups/${groupID}/setpoints/admin/objects/nousage`;

        const response = await restService.post<ISummarySearchDTO, ISummaryObjectsDTO>(path, searchCriteria, signal);
        return response.data;

    },

    getSetpointsWithoutObjects: async function(groupID: number,
        searchCriteria: ISummarySearchDTO,
        signal?: AbortSignal
    ) : Promise<ISummaryDTO> {

        const path = `/groups/${groupID}/setpoints/admin/nousage`;

        const response = await restService.post<ISummarySearchDTO, ISummaryDTO>(path, searchCriteria, signal);
        return response.data;

    },

    getSetpoint: async function(groupID: number,
        organizationID: number,
        setpointID: number | undefined,
        signal?: AbortSignal
        ) : Promise<IEditDTO> {

            if (setpointID) {
                const path = `/groups/${groupID}/setpoints/${setpointID}`;
                const response = await restService.get<IEditDTO>(path, signal);
                response.data.originalNotificationLists = response.data.notificationLists;
                return response.data;
            }

             //const setPoint = new SetPointAdministrationModels.EditModel(null);
             //setPoint.organizationId = organizationId;
             const setpoint: IEditDTO = {...defaultEditSetpoint,
                organizationID: organizationID
             };


             return setpoint;
    },
    saveSetpoint: async function(groupID: number, setpoint: IEditDTO, signal?: AbortSignal) : Promise<IEditDTO> {
        const path = `/groups/${groupID}/setpoints`;
        const response = await restService.put<IEditDTO, IEditDTO>(path, setpoint, signal);
        return response.data;
    },
    deleteSetpoint: async function(groupID: number, setpointID: number): Promise<void> {
        const path = `/groups/${groupID}/setpoints/${setpointID}`;
        await restService.delete(path);
    },
    testSetpoint: async function (groupID: number, setpointID: number, tagID?: number): Promise<void> {

        const path = `/groups/${groupID}/setpoints/${setpointID}/tags/${tagID}/test`;
        await restService.post<undefined, undefined>(path, undefined);
    },
    getSimilarSetpoints: async function(groupID: number, orgID: number, tagID: number, signal?: AbortSignal) : Promise<ISummaryDTO> {

        const path = `/groups/${groupID}/organizations/${orgID}/tags/${tagID}/setpoints`;
        const response = await restService.get<ISummaryDTO>(path, signal);
        return response.data;
    },
    linkTagToSetpoints: async function(groupID: number, tagID: number, setpoints: number[]): Promise<void> {
        const path = `/groups/${groupID}/tags/${tagID}/linktosetpoints`;
        await restService.post<number[], undefined>(path, setpoints);
    },



//     // Retrieve Alarm Setpoints that have no usage for Objects in the current Group.
//     public getAdminSetpointsWithoutObjects(groupId: number, page: number, pageSize: number,
//         searchCriteria: SetPointAdministrationModels.ISummarySearchDTO):
//         Services.RestPromise<SetPointAdministrationModels.ISummaryDTO> {

//         page = Number(page);
//         pageSize = Number(pageSize);

//         //         [Route("~/v1/groups/{groupID:int}/setpoints/admin/setpoints/nousage")]

//         const path = [
//             "groups",
//             groupId,
//             "setpoints",
//             "admin",
//             "nousage"
//         ].join("/");

//         const queryParams = {
//             page: page,
//             pageSize: pageSize
//         };

//         return this._restService
//             .post<SetPointAdministrationModels.ISummaryDTO, any>(path, searchCriteria, null, queryParams)
//             .then(data => {

//                 return data.entity;

//             });
//     }


    getReferenceData: async function (groupID: number,
        organizationID: number,
        signal?: AbortSignal
    ) : Promise<IReferenceDTO> {

        const path = `/groups/${groupID}/setpoints/referenceData`;

        const queryParams: SetpointAdminQueryParams = {
            organizationID,

        };

        const response = await restService.get<IReferenceDTO, SetpointAdminQueryParams>(path, signal, queryParams);
        return response.data;
    },
    // tagObject???
    getAvailableUsageObjects: async function(groupID: number,
        searchCriteria: IEditTagSearchCriteriaDTO,
        signal?: AbortSignal): Promise<IEditTagSearchResultDeviceDTO[]> {

        const path = `/groups/${groupID}/setpoints/tagobjects`;

        const response = await restService.post<IEditTagSearchCriteriaDTO, IEditTagSearchResultDeviceDTO[]>(path, searchCriteria, signal);
        return response.data;
    
    },






//     public tagObject(groupId: number, searchCriteria:SetPointAdministrationModels.IEditTagSearchCriteriaDTO)
//         : Services.RestPromise<Array<SetPointAdministrationModels.IEditTagSearchResultDeviceDTO>> {

//         // "~/groups/{groupID:int}/setpoints/tagobjects"

//         const path = [
//             "groups",
//             groupId,
//             "setpoints",
//             "tagobjects"
//         ].join("/");

//         return this._restService
//             .post<Array<SetPointAdministrationModels.IEditTagSearchResultDeviceDTO>, any>(path, searchCriteria)
//             .then(data => {

//                 return data.entity;

//             });
//     }



//     public getReferenceData(groupId: number, organizationId: number, forceRefresh: boolean = false)
//         : Services.RestPromise<SetPointAdministrationModels.IReferenceDTO> {

//         // Determine if we need to make a request
//         const newParams = [groupId, organizationId].join(";");

//         if (forceRefresh || (newParams !== this._getReferenceData_Previous_Params)) {

//             // Store for next time
//             this._getReferenceData_Previous_Params = newParams;

//             // "~/groups/{groupID:int}/setpoints/referenceData?organizationID={organizationId}"
//             const path = [
//                 "groups",
//                 groupId,
//                 "setpoints",
//                 "referencedata"
//             ].join("/");

//             const queryParams = {
//                 organizationID: organizationId
//             };

//             // Retrieve reference data
//             return this._restService
//                 .get<SetPointAdministrationModels.IReferenceDTO, any>(path, queryParams)
//                 .then(data => {

//                     // Store for next time
//                     this._getReferenceData_Previous_Results = data.entity;

//                     return data.entity;

//                 });
//         } else {
//             // No need to make a server request; return previously stored results
//             return When.resolve(this._getReferenceData_Previous_Results);

//         }
//     }


//     // Fields used to determine if we need to make a request
//     private _getReferenceData_Previous_Params: string = null;
//     private _getReferenceData_Previous_Results: SetPointAdministrationModels.IReferenceDTO = null;



//     ///////////////////////////////////////////////////////////////////////////////////////////////
//     // getSetPoint - implementation, supporting fields and methods
//     ///////////////////////////////////////////////////////////////////////////////////////////////

//     public getSetPoint(groupId: number, organizationId: number = null, setPointId: number = null)
//         : Services.RestPromise<SetPointAdministrationModels.IEditDTO> {

//         organizationId = Number(organizationId);
//         setPointId = Number(setPointId);

//         if (setPointId > 0) {

//             // "~/groups/{groupID:int}/setpoints/{setPointID:int}"
//             const path = [
//                 "groups",
//                 groupId,
//                 "setpoints",
//                 setPointId
//             ].join("/");

//             return this._restService
//                 .get<SetPointAdministrationModels.IEditDTO>(path)
//                 .then(data => {

//                     return data.entity;

//                 });
//         } else {

//             // Create an empty/new Alarm Setpoint
//             const setPoint = new SetPointAdministrationModels.EditModel(null);
//             setPoint.organizationId = organizationId;

//             return When.resolve(setPoint.toDataTransferObject());

//         }
//     }



















    // acknowledgeAlarm: async function (
    //     groupID: number,
    //     tagID: number,
    //     setpointID: number,
    //     signal?: AbortSignal): Promise<void> {

    //     var path: string = `groups/${groupID}/tags/${tagID}/setpoints/${setpointID}/acknowledge`;

    //     const response = await restService.get<void>(path, signal);
    //     return response.data;
    // },

    // // Not sure where to locate these yet

    // disableTagSetPoint: async function (
    //     groupId: number,
    //     tagId: number,
    //     setPointId: number,
    //     disabledSchedule: IDisabledScheduleDTO,
    //     signal?: AbortSignal
    // ): Promise<void> {

    //     // "~/groups/{groupID:int}/tags/{tagID:int}/setpoints/{setPointID:int}/disable"
    //     const path = [
    //         "groups",
    //         groupId,
    //         "tags",
    //         tagId,
    //         "setpoints",
    //         setPointId,
    //         "disable"
    //     ].join("/");

    //     /*const response =*/ await restService.put<IDisabledScheduleDTO, void>(path, disabledSchedule, signal);
    // },

    // enableTagSetPoint: async function (
    //     groupId: number,
    //     tagId: number,
    //     setPointId: number,
    //     signal?: AbortSignal
    // ): Promise<void> {

    //     // "~/groups/{groupID:int}/tags/{tagID:int}/setpoints/{setPointID:int}/enable"
    //     const path = [
    //         "groups",
    //         groupId,
    //         "tags",
    //         tagId,
    //         "setpoints",
    //         setPointId,
    //         "enable"
    //     ].join("/");

    //     await restService.put<undefined, void>(path, undefined, signal);
    // },


    // getDisabledScheduleForTagSetPoint: async function (
    //     groupId: number,
    //     tagId: number,
    //     setPointId: number,
    //     signal?: AbortSignal
    // ): Promise<IDisabledScheduleDTO> {

    //     // "~/groups/{groupID:int}/tags/{tagID:int}/setpoints/{setPointID:int}/disabledSchedule"
    //     const path = [
    //         "groups",
    //         groupId,
    //         "tags",
    //         tagId,
    //         "setpoints",
    //         setPointId,
    //         "disabledSchedule"
    //     ].join("/");

    //     const response = await restService.get<IDisabledScheduleDTO>(path, signal);
    //     return response.data;
    // }
};

export default SetpointAdministrationDataService;

//     public copySetPoint(groupId: number, setPointId: number)
//         : Services.RestPromise<SetPointAdministrationModels.IEditDTO> {

//         // "~/groups/{groupID:int}/setpoints/{setPointID:int}/copy"
//         const path = [
//             "groups",
//             groupId,
//             "setpoints",
//             setPointId,
//             "copy"
//         ].join("/");

//         return this._restService
//             .post<SetPointAdministrationModels.IEditDTO>(path, null)
//             .then(data => {

//                 return data.entity;

//             });
//     }


//     ///////////////////////////////////////////////////////////////////////////////////////////////
//     // copySetPoint_v2 - same as above, but for the new setpoint experience
//     ///////////////////////////////////////////////////////////////////////////////////////////////

//     public copySetPoint_v2(groupId: number, setPointId: number)
//         : Services.RestPromise<SetPointAdministrationModels.IEditDTO> {

//         // "~/groups/{groupID:int}/setpoints/{setPointID:int}/copy_v2"
//         const path = [
//             "groups",
//             groupId,
//             "setpoints",
//             setPointId,
//             "copy_v2"
//         ].join("/");

//         return this._restService
//             .post<SetPointAdministrationModels.IEditDTO>(path, null)
//             .then(data => {

//                 return data.entity;

//             });
//     }



//     ///////////////////////////////////////////////////////////////////////////////////////////////
//     // deleteSetPoint - implementation, supporting fields and methods
//     ///////////////////////////////////////////////////////////////////////////////////////////////

//     public deleteSetPoint(groupId: number, setPointId: number)
//         : Services.RestPromise<any> {

//         // "~/groups/{groupID:int}/setpoints/{setPointID:int}"
//         const path = [
//             "groups",
//             groupId,
//             "setpoints",
//             setPointId
//         ].join("/");

//         return this._restService
//             .delete(path)
//             .then(data => {

//                 return data.entity;

//             });
//     }



//     ///////////////////////////////////////////////////////////////////////////////////////////////
//     // disableTagSetPoint - implementation, supporting fields and methods
//     ///////////////////////////////////////////////////////////////////////////////////////////////

//     public disableTagSetPoint(groupId: number, tagId: number, setPointId: number, disabledSchedule: SetPointAdministrationModels.IDisabledScheduleDTO)
//         : Services.RestPromise<any> {

//         // "~/groups/{groupID:int}/tags/{tagID:int}/setpoints/{setPointID:int}/disable"
//         const path = [
//             "groups",
//             groupId,
//             "tags",
//             tagId,
//             "setpoints",
//             setPointId,
//             "disable"
//         ].join("/");

//         return this._restService
//             .put<SetPointAdministrationModels.IDisabledScheduleDTO>(path, disabledSchedule)
//             .then(data => {

//                 return data.entity;

//             });
//     }



//     ///////////////////////////////////////////////////////////////////////////////////////////////
//     // enableTagSetPoint - implementation, supporting fields and methods
//     ///////////////////////////////////////////////////////////////////////////////////////////////

//     public enableTagSetPoint(groupId: number, tagId: number, setPointId: number)
//         : Services.RestPromise<any> {

//         // "~/groups/{groupID:int}/tags/{tagID:int}/setpoints/{setPointID:int}/enable"
//         const path = [
//             "groups",
//             groupId,
//             "tags",
//             tagId,
//             "setpoints",
//             setPointId,
//             "enable"
//         ].join("/");

//         return this._restService
//             .put<any>(path, null)
//             .then(data => {

//                 return data.entity;

//             });
//     }



//     ///////////////////////////////////////////////////////////////////////////////////////////////
//     // getDisabledScheduleForTagSetPoint - implementation, supporting fields and methods
//     ///////////////////////////////////////////////////////////////////////////////////////////////

//     public getDisabledScheduleForTagSetPoint(groupId: number, tagId: number, setPointId: number)
//         : Services.RestPromise<SetPointAdministrationModels.IDisabledScheduleDTO> {

//         // "~/groups/{groupID:int}/tags/{tagID:int}/setpoints/{setPointID:int}/disabledSchedule"
//         const path = [
//             "groups",
//             groupId,
//             "tags",
//             tagId,
//             "setpoints",
//             setPointId,
//             "disabledSchedule"
//         ].join("/");

//         return this._restService
//             .get<SetPointAdministrationModels.IDisabledScheduleDTO>(path)
//             .then(data => {

//                 return data.entity;

//             });
//     }


//     ///////////////////////////////////////////////////////////////////////////////////////////////
//     // getReferenceData - implementation, supporting fields and methods
//     ///////////////////////////////////////////////////////////////////////////////////////////////

//     public getReferenceData(groupId: number, organizationId: number, forceRefresh: boolean = false)
//         : Services.RestPromise<SetPointAdministrationModels.IReferenceDTO> {

//         // Determine if we need to make a request
//         const newParams = [groupId, organizationId].join(";");

//         if (forceRefresh || (newParams !== this._getReferenceData_Previous_Params)) {

//             // Store for next time
//             this._getReferenceData_Previous_Params = newParams;

//             // "~/groups/{groupID:int}/setpoints/referenceData?organizationID={organizationId}"
//             const path = [
//                 "groups",
//                 groupId,
//                 "setpoints",
//                 "referencedata"
//             ].join("/");

//             const queryParams = {
//                 organizationID: organizationId
//             };

//             // Retrieve reference data
//             return this._restService
//                 .get<SetPointAdministrationModels.IReferenceDTO, any>(path, queryParams)
//                 .then(data => {

//                     // Store for next time
//                     this._getReferenceData_Previous_Results = data.entity;

//                     return data.entity;

//                 });
//         } else {
//             // No need to make a server request; return previously stored results
//             return When.resolve(this._getReferenceData_Previous_Results);

//         }
//     }


//     // Fields used to determine if we need to make a request
//     private _getReferenceData_Previous_Params: string = null;
//     private _getReferenceData_Previous_Results: SetPointAdministrationModels.IReferenceDTO = null;



//     ///////////////////////////////////////////////////////////////////////////////////////////////
//     // getSetPoint - implementation, supporting fields and methods
//     ///////////////////////////////////////////////////////////////////////////////////////////////

//     public getSetPoint(groupId: number, organizationId: number = null, setPointId: number = null)
//         : Services.RestPromise<SetPointAdministrationModels.IEditDTO> {

//         organizationId = Number(organizationId);
//         setPointId = Number(setPointId);

//         if (setPointId > 0) {

//             // "~/groups/{groupID:int}/setpoints/{setPointID:int}"
//             const path = [
//                 "groups",
//                 groupId,
//                 "setpoints",
//                 setPointId
//             ].join("/");

//             return this._restService
//                 .get<SetPointAdministrationModels.IEditDTO>(path)
//                 .then(data => {

//                     return data.entity;

//                 });
//         } else {

//             // Create an empty/new Alarm Setpoint
//             const setPoint = new SetPointAdministrationModels.EditModel(null);
//             setPoint.organizationId = organizationId;

//             return When.resolve(setPoint.toDataTransferObject());

//         }
//     }



//     ///////////////////////////////////////////////////////////////////////////////////////////////
//     // getSetPoints - implementation, supporting fields and methods
//     ///////////////////////////////////////////////////////////////////////////////////////////////

//     public getSetPoints(groupId: number, page: number, pageSize: number, searchCriteria: SetPointAdministrationModels.ISummarySearchDTO)
//         : Services.RestPromise<SetPointAdministrationModels.ISummaryDTO> {

//         page = Number(page);
//         pageSize = Number(pageSize);

//         // "~/groups/{groupID:int}/setpoints"
//         const path = [
//             "groups",
//             groupId,
//             "setpoints"
//         ].join("/");

//         const queryParams = {
//             page: page,
//             pageSize: pageSize
//         };

//         return this._restService
//             .post<SetPointAdministrationModels.ISummaryDTO, any>(path, searchCriteria, null, queryParams)
//             .then(data => {

//                 return data.entity;

//             });
//     }

//     public getAdminSetPointsForGroup(groupId: number, page: number, pageSize: number,
//         searchCriteria: SetPointAdministrationModels.ISummarySearchDTO):
//         Services.RestPromise<SetPointAdministrationModels.ISummaryDTO> {

//         page = Number(page);
//         pageSize = Number(pageSize);

//         const path = [
//             "groups",
//             groupId,
//             "setpoints",
//             "admin"
//         ].join("/");

//         const queryParams = {
//             page: page,
//             pageSize: pageSize
//         };

//         return this._restService
//             .post<SetPointAdministrationModels.ISummaryDTO, any>(path, searchCriteria, null, queryParams)
//             .then(data => {

//                 return data.entity;
//             });
//     }

//     public getAdminGroupedObjectSetPointsForGroup(groupId: number, page: number, pageSize: number,
//         groupingObjectType: Enums.eLynxObjectTypeEnum, searchCriteria: SetPointAdministrationModels.ISummarySearchDTO):
//         Services.RestPromise<SetPointAdministrationModels.ISummaryGroupedObjectsDTO> {

//         page = Number(page);
//         pageSize = Number(pageSize);

//         const path = [
//             "groups",
//             groupId,
//             "setpoints",
//             "admin",
//             "grouped"
//         ].join("/");

//         const queryParams = {
//             page: page,
//             pageSize: pageSize,
//             groupingObjectType: groupingObjectType
//         };

//         return this._restService
//             .post<SetPointAdministrationModels.ISummaryGroupedObjectsDTO, any>(path, searchCriteria, null, queryParams)
//             .then(data => {

//                 return data.entity;
//             });
//     }

//     public getAdminObjectsWithoutSetpoints(groupId: number, page: number, pageSize: number,
//         searchCriteria: SetPointAdministrationModels.ISummarySearchDTO):
//         Services.RestPromise<SetPointAdministrationModels.ISummaryObjectsDTO> {

//         page = Number(page);
//         pageSize = Number(pageSize);

//         // "~/groups/{groupID:int}/setpoints"
//         const path = [
//             "groups",
//             groupId,
//             "setpoints",
//             "admin",
//             "objects",
//             "nousage"
//         ].join("/");

//         const queryParams = {
//             page: page,
//             pageSize: pageSize
//         };

//         return this._restService
//             .post<SetPointAdministrationModels.ISummaryObjectsDTO, any>(path, searchCriteria, null, queryParams)
//             .then(data => {

//                 return data.entity;
//             });
//     }

//     // Retrieve Alarm Setpoints that have no usage for Objects in the current Group.
//     public getAdminSetpointsWithoutObjects(groupId: number, page: number, pageSize: number,
//         searchCriteria: SetPointAdministrationModels.ISummarySearchDTO):
//         Services.RestPromise<SetPointAdministrationModels.ISummaryDTO> {

//         page = Number(page);
//         pageSize = Number(pageSize);

//         //         [Route("~/v1/groups/{groupID:int}/setpoints/admin/setpoints/nousage")]

//         const path = [
//             "groups",
//             groupId,
//             "setpoints",
//             "admin",
//             "nousage"
//         ].join("/");

//         const queryParams = {
//             page: page,
//             pageSize: pageSize
//         };

//         return this._restService
//             .post<SetPointAdministrationModels.ISummaryDTO, any>(path, searchCriteria, null, queryParams)
//             .then(data => {

//                 return data.entity;

//             });
//     }

//     ///////////////////////////////////////////////////////////////////////////////////////////////
//     // getSetPointUsage - implementation, supporting fields and methods
//     ///////////////////////////////////////////////////////////////////////////////////////////////

//     public getSetPointUsage(groupId: number, setPointId: number):
//         Services.RestPromise<Array<SetPointAdministrationModels.ISummaryUsageDTO>> {

//         setPointId = Number(setPointId);

//         // "~/groups/{groupID:int}/setpoints/{setPointID:int}/usage"
//         const path = [
//             "groups",
//             groupId,
//             "setpoints",
//             setPointId,
//             "usage"
//         ].join("/");

//         return this._restService
//             .get<Array<SetPointAdministrationModels.ISummaryUsageDTO>>(path)
//             .then(data => {

//                 return data.entity;

//             });
//     }

//     public getSetPointUsage_v2(groupId: number, setPointId: number):
//         Services.RestPromise<Array<SetPointAdministrationModels.ISummaryUsageDTO>> {

//         setPointId = Number(setPointId);

//         // "~/groups/{groupID:int}/setpoints/{setPointID:int}/usage/admin"
//         const path = [
//             "groups",
//             groupId,
//             "setpoints",
//             setPointId,
//             "usage",
//             "admin"
//         ].join("/");

//         return this._restService
//             .get<Array<SetPointAdministrationModels.ISummaryUsageDTO>>(path)
//             .then(data => {

//                 return data.entity;

//             });
//     }

//     ///////////////////////////////////////////////////////////////////////////////////////////////
//     // getSimilarSetPoints - implementation, supporting fields and methods
//     ///////////////////////////////////////////////////////////////////////////////////////////////
    
//     public getSimilarSetPoints(groupId: number, orgId: number, tagId: number)
//         : Services.RestPromise<SetPointAdministrationModels.ISummaryDTO> {

//         // ~/groups/{groupID:int}/organizations/{organizationID:int}/tags/{tagID:int}/setpoints
//         const path = [
//             "groups",
//             groupId,
//             "organizations",
//             orgId,
//             "tags",
//             tagId,
//             "setpoints"
//         ].join("/");

//         return this._restService
//             .get<SetPointAdministrationModels.ISummaryDTO>(path)
//             .then(data => {

//                 return data.entity;

//             });
//     }

//     ///////////////////////////////////////////////////////////////////////////////////////////////
//     // linkTagToSetPoints - implementation, supporting fields and methods
//     ///////////////////////////////////////////////////////////////////////////////////////////////

//     public linkTagToSetPoints(groupId: number, tagID: number, tagSetPointIDs: Array<number>)
//         : any {

//         // ~/groups/{groupID:int}/organizations/{organizationID:int}/tags/{tagID:int}/setpoints
//         const path = [
//             "groups",
//             groupId,
//             "tags",
//             tagID,
//             "linktosetpoints"
//         ].join("/");

//         return this._restService
//             .post(path, tagSetPointIDs)
//             .then((data: Services.IRestResponse<string>) => {
//                 return data.entity;
//             });

//     }

//     ///////////////////////////////////////////////////////////////////////////////////////////////
//     // saveSetPoint - implementation, supporting fields and methods
//     ///////////////////////////////////////////////////////////////////////////////////////////////

//     public saveSetPoint(groupId: number, setPoint: SetPointAdministrationModels.IEditDTO)
//         : Services.RestPromise<any> {

//         // "~/groups/{groupID:int}/setpoints"
//         const path = [
//             "groups",
//             groupId,
//             "setpoints"
//         ].join("/");

//         return this._restService
//             .put<SetPointAdministrationModels.IEditDTO>(path, setPoint)
//             .then(data => {

//                 return data.entity;

//             });
//     }



//     ///////////////////////////////////////////////////////////////////////////////////////////////
//     // tagSearch - implementation, supporting fields and methods
//     ///////////////////////////////////////////////////////////////////////////////////////////////

//     public tagSearch(groupId: number, searchCriteria: SetPointAdministrationModels.IEditTagSearchCriteriaDTO)
//         : Services.RestPromise<Array<SetPointAdministrationModels.IEditTagSearchResultDeviceDTO>> {

//         // "~/groups/{groupID:int}/setpoints/tagsearch"
//         const path = [
//             "groups",
//             groupId,
//             "setpoints",
//             "tagsearch"
//         ].join("/");

//         return this._restService
//             .post<Array<SetPointAdministrationModels.IEditTagSearchResultDeviceDTO>, any>(path, searchCriteria)
//             .then(data => {

//                 return data.entity;

//             });
//     }

//     ///////////////////////////////////////////////////////////////////////////////////////////////
//     // tagObjects - implementation, supporting fields and methods
//     ///////////////////////////////////////////////////////////////////////////////////////////////

//     public tagObject(groupId: number, searchCriteria:SetPointAdministrationModels.IEditTagSearchCriteriaDTO)
//         : Services.RestPromise<Array<SetPointAdministrationModels.IEditTagSearchResultDeviceDTO>> {

//         // "~/groups/{groupID:int}/setpoints/tagobjects"

//         const path = [
//             "groups",
//             groupId,
//             "setpoints",
//             "tagobjects"
//         ].join("/");

//         return this._restService
//             .post<Array<SetPointAdministrationModels.IEditTagSearchResultDeviceDTO>, any>(path, searchCriteria)
//             .then(data => {

//                 return data.entity;

//             });
//     }


//     ///////////////////////////////////////////////////////////////////////////////////////////////
//     // testSetPoint - implementation, supporting fields and methods
//     ///////////////////////////////////////////////////////////////////////////////////////////////

//     public testSetPoint(groupId: number, setPointId: number)
//         : Services.RestPromise<any> {

//         // "~/groups/{groupID:int}/setpoints/{setPointID:int}/test"
//         const path = [
//             "groups",
//             groupId,
//             "setpoints",
//             setPointId,
//             "test"
//         ].join("/");

//         return this._restService
//             .post<SetPointAdministrationModels.IEditDTO>(path, null)
//             .then(data => {

//                 return data.entity;

//             });
//     }


//     ///////////////////////////////////////////////////////////////////////////////////////////////
//     // testSetPointForSingleTag - implementation, supporting fields and methods
//     ///////////////////////////////////////////////////////////////////////////////////////////////

//     public testSetPointForSingleTag(groupId: number, setPointId: number, tagId: number)
//         : Services.RestPromise<any> {

//         // "~/groups/{groupID:int}/setpoints/{setPointID:int}/tags/{tagID:int}/test"
//         const path = [
//             "groups",
//             groupId,
//             "setpoints",
//             setPointId,
//             "tags",
//             tagId,
//             "test"
//         ].join("/");

//         return this._restService
//             .post<SetPointAdministrationModels.IEditDTO>(path, null)
//             .then((data) => {

//                 return data.entity;

//             });
//     }
// }

// var instance = null;

// function factory(restService: Services.IRestService) {
//     if (!instance) {
//         instance = new SetPointAdministrationService(restService);
//     }
//     return instance;
// }

// export = factory;
